import * as React from 'react';
import { ReactNode } from 'react';
import Card from './Card';
import CheckBox from './CheckBox';
import Tooltip from './Tooltip';
import '../css/add-on-channel-card.sass';

interface AddOnChannelCardProps {
  id: string;
  imageUrl?: string;
  channelName: string;
  toolTip?: ReactNode;
  title: string;
  selectable?: boolean;
  description?: ReactNode;
  checked?: boolean;
  onChange?: Function;
}

export default function AddOnChannelCard(props: AddOnChannelCardProps) {
  return (
    <div className="add-on-channel-card">
      <Card>
        {window.innerWidth > 992 && (
          <>
            <Tooltip toolTip={props.toolTip} />
            <div className="img-content">
              {props.imageUrl ? (
                <img
                  className="pkg-img"
                  alt={props.channelName}
                  src={props.imageUrl}
                />
              ) : (
                <span className="no-img-channel-txt">{props.channelName}</span>
              )}
            </div>
            <div className="pkg-divider" />
          </>
        )}
        <div
          className={
            !(window.innerWidth > 992) && props.description
              ? ''
              : 'no-additional-info'
          }
        >
          <CheckBox
            id={props.id}
            label={window.innerWidth > 992 ? props.title : props.channelName}
            name={props.channelName}
            value={window.innerWidth > 992 ? props.title : props.channelName}
            description={
              window.innerWidth > 992 ? props.description : props.title
            }
            onChange={props.onChange}
            checked={props.checked}
            disabled={!props.selectable && props.selectable !== undefined}
          />
        </div>
        {!(window.innerWidth > 992) && (
          <div className="additional-info">{props.description}</div>
        )}
      </Card>
    </div>
  );
}
